const activityGuidePage = () => {
  return '/activity-guide-page'
}

export default activityGuidePage